import React from "react";
import TimeBlockCell from "./TimeBlockCell";
import BoardRow from "./BoardRow";

export default function DailyBoard({
  BOARD_BLOCKS = [],
  visibleRoleKeys = [],
  roleOptions,
  isTablet = false,
  dailyByBlockRole = {},
  PlannerShiftCard,
  LifecycleBoxes,
  cardHeightForCount,
  visibleCardsForCount,
  cellHeightForBlock,
  openOverflow = () => {},
}) {
  return (
    <>
      {BOARD_BLOCKS.map((blk) => (
        <div
          key={blk.key}
          style={{
            display: "grid",
            gridTemplateColumns: `84px repeat(${visibleRoleKeys.length}, minmax(${isTablet ? 146 : 156}px, 1fr))`,
            gap: 7,
            marginBottom: 7,
            alignItems: "stretch",
          }}
        >
          <TimeBlockCell block={blk} />

          <BoardRow
            block={blk}
            visibleRoleKeys={visibleRoleKeys}
            roleOptions={roleOptions}
            dailyByBlockRole={dailyByBlockRole}
            PlannerShiftCard={PlannerShiftCard}
            LifecycleBoxes={LifecycleBoxes}
            cardHeightForCount={cardHeightForCount}
            visibleCardsForCount={visibleCardsForCount}
            cellHeightForBlock={cellHeightForBlock}
            openOverflow={openOverflow}
          />
        </div>
      ))}
    </>
  );
}